<template>
  <div
    v-if="isShow"
    :class="['lds-ring', isBlack ? 'black-ring' : '']"
    v-bind="$attrs"
  >
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
</template>

<script lang="ts" setup>
import { toRefs, watch } from 'vue';

const props = defineProps<{
  isBlack?: boolean;
  isShow?: boolean;
}>();

const { isBlack, isShow } = toRefs(props);
</script>

<style lang="scss" scoped>
@use '@css/mixin';
.lds-ring {
  display: inline-block;
  position: relative;
  width: 16px;
  height: 14px;
}
.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 16px;
  height: 16px;
  margin: 0 2px;
  border: 2px solid var(--color-white);
  border-radius: 100px;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: var(--color-white) transparent transparent transparent;
}
.black-ring div {
  border: 2px solid var(--color-black);
  border-color: var(--color-black) transparent transparent transparent;
}
.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}
@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>

<style lang="scss" scoped>
[dir='rtl'] {
  .lds-ring {
    margin-left: 5px;
    margin-right: 0px;
  }
}
</style>
